import script from "./labheader.vue?vue&type=script&setup=true&lang=js"
export * from "./labheader.vue?vue&type=script&setup=true&lang=js"

import "./labheader.vue?vue&type=style&index=0&id=4132e2a6&lang=less&scoped=true"

import exportComponent from "D:\\项目\\中国科学院大学-预测研究中心\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4132e2a6"]])

export default __exports__